import { render, staticRenderFns } from "./company-introduction.vue?vue&type=template&id=7e0cd074&scoped=true&"
import script from "./company-introduction.vue?vue&type=script&lang=js&"
export * from "./company-introduction.vue?vue&type=script&lang=js&"
import style0 from "./company-introduction.vue?vue&type=style&index=0&id=7e0cd074&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0cd074",
  null
  
)

export default component.exports